import script from "./ShakyoRightBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoRightBar.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoRightBar.vue?vue&type=style&index=0&id=62a1b644&scoped=true&lang=css"
import "./ShakyoRightBar.vue?vue&type=style&index=1&id=62a1b644&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a1b644"]])

export default __exports__